import { NuqsAdapter } from "nuqs/adapters/react-router/v8";
import { useState } from "react";
import { BrowserRouter } from "react-router";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import AppRoutes from "./AppRoutes";
import { useFrontendUpdate } from "./lib/useFrontendUpdate";
import { usePostHogIdentify } from "./lib/usePostHogIdentify";
import { usePostHogPageviews } from "./lib/usePostHogPageviews";

function PostHogObservers() {
	usePostHogPageviews();
	usePostHogIdentify();
	return null;
}

function UpdatePromptListener() {
	const { updateAvailable, serverSha, reload } = useFrontendUpdate("app");
	const [promptedSha, setPromptedSha] = useState<string | null>(null);
	// Keyed on the server's SHA so a second deploy within the same session
	// re-fires the toast for the new version (covers the rare case where
	// the user ignores the first prompt and a third deploy lands).
	if (updateAvailable && serverSha !== null && promptedSha !== serverSha) {
		setPromptedSha(serverSha);
		toast("New version available", {
			description: "Reload to get the latest update.",
			duration: Number.POSITIVE_INFINITY,
			action: { label: "Reload", onClick: reload },
			closeButton: true,
		});
	}
	return null;
}

export default function App() {
	return (
		<TooltipProvider>
			<BrowserRouter>
				<PostHogObservers />
				<UpdatePromptListener />
				<NuqsAdapter>
					<AppRoutes />
				</NuqsAdapter>
				<Toaster />
			</BrowserRouter>
		</TooltipProvider>
	);
}
